import React from 'react';
import { Redirect } from 'react-router-dom';

export default WrappedComponent => ({ location, ...props }) => {
    const lastVisited = window.localStorage.getItem('lastVisited');
    return (location.state && location.state.fromLink) || !lastVisited ? <WrappedComponent {...props} /> : <Redirect to={lastVisited} />
}